
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 2.5a10.1 10.1 0 016 1.5 706.985 706.985 0 0136 27 9.468 9.468 0 00-1.5 2.5 422.774 422.774 0 01-19.5 15A1192.742 1192.742 0 016.5 25c-1.297-2.545-1.13-5.045.5-7.5a260.927 260.927 0 0012.5-15zm26 28c1.837.14 2.17.806 1 2-.797-.457-1.13-1.124-1-2z","opacity":".925"}}),_c('path',{attrs:{"d":"M-.5 60.5v-24h4v6c3.63.34 6.964-.494 10-2.5-1.528-2.518-1.194-4.685 1-6.5a271.079 271.079 0 0116 11.5c-1.897 3.29-4.564 4.29-8 3-5.361 4.843-11.695 7.01-19 6.5.901 3.74-.432 5.74-4 6z","opacity":".874"}}),_c('path',{attrs:{"d":"M63.5 35.5v5a140.166 140.166 0 00-9 10.5c-2.832.04-5.165-1.127-7-3.5 4.528-5.21 9.861-9.21 16-12z","opacity":".739"}})])
          )
        }
      }
    